// on login page
export const AUTH_OTP_SUCCESS = "auth/AUTH_OTP_SUCCESS";
export const AUTH_OTP_FAILURE = "auth/AUTH_OTP_FAILURE";
export const AUTH_LOGIN_SUCCESS = "auth/AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "auth/AUTH_LOGIN_FAILURE";
// on logout button
//export const AUTH_LOGOUT = "auth/AUTH_LOGOUT_SUCCESS";
